import './styles.scss'
import {IWidgetResponse} from '../../../api/Base/Base.types'
import {ResponsivePie} from '@nivo/pie';
import {IOnTimeArrival} from "../../../api/OnTimeArrival/OnTimeArrival.types";
import {Stack, Text} from "@mantine/core";
import {ResponsiveBar} from "@nivo/bar";
import NumberUtils from "../../../utils/number.utils";
import WidgetNivoBase from "../Widget.nivo.base";

interface Props {
    data?: IWidgetResponse<IOnTimeArrival>
}

function OnTimeArrival({data}: Props) {
    function renderGraph() {
        if (data?.data && data.data[0]) {
            let onTimeArrivalData = data.data[0]

            let curData = [
                {
                    id: "lateCount",
                    label: "Late Count",
                    value: onTimeArrivalData.lateCount
                },
                {
                    id: "onTime",
                    label: "On Time",
                    value: onTimeArrivalData.totalCount - onTimeArrivalData.lateCount
                }
            ]
            const CenteredMetric = ({dataWithArc, centerX, centerY}: any) => {
                let total = 0
                dataWithArc.forEach((datum: any) => {
                    total += datum.value
                })

                return (
                    <text
                        x={centerX}
                        y={centerY}
                        textAnchor="middle"
                        dominantBaseline="central"
                        style={{
                            fontSize: '24px',
                            fontWeight: 600,
                        }}
                    >
                        {(onTimeArrivalData.onTimePercentage * 100).toFixed(2)}%
                    </text>
                )
            }
            return (
                <ResponsivePie
                    margin={{top: 20, right: 20, bottom: 20, left: 20}}
                    data={curData}
                    colors={{scheme: "category10"}}
                    enableArcLabels={false}
                    innerRadius={0.6}
                    arcLinkLabel={d => `${d.label} (${d.formattedValue})`}
                    activeOuterRadiusOffset={8}
                    layers={['arcs', 'arcLabels', 'arcLinkLabels', 'legends', CenteredMetric]}
                />
            )
        } else {
            return (
                <Stack align="center">
                    <Text>No Data Found</Text>
                </Stack>
            )
        }
    }

    return (
        <div className="on-time-arrival">
            <div className="widget-nivo-base">
                <div className='header'>
                    <Text>
                        On Time Arrival
                    </Text>
                </div>
                <div className='widget-chart-container'>
                    {renderGraph()}
                </div>
            </div>

        </div>
    )
}

export default OnTimeArrival;